exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Montserrat:200,400,500,600,700);", ""]);

// module
exports.push([module.id, ".fade-enter-active,.fade-leave-active{transition:opacity .5s}.fade-enter,.fade-leave-to{opacity:0}.product--grid--component{padding-bottom:50px;position:relative}.product--grid--component.loading:after{content:\"\";box-sizing:border-box;position:absolute;bottom:0;left:calc(50% - 20px);width:40px;height:40px;margin-top:-10px;margin-left:-10px;border-radius:50%;border:4px solid #fff;border-top-color:#eb0029;animation:spinner 1s linear infinite}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-36f1f5cc","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./web/webroot/_ui/responsive/common/js/src/components/productgrid/productgrid.scss
// module id = 827
// module chunks = 39